import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";

import { getJobDetailsRoute } from "../../../../routers/routeUtils";

import { BackButtonIcon } from "../../assets/icons/go-hire-page-icons";
import { GinoCandidateSummary, UnlockAdvancedHiringTools } from "../../components";

import { useGetCandidateReview } from "../../api/queries/useGetCandidateReview";
import { useUserProfile } from "../../../User/api/queries/useUserProfile";

import CandidateInfo from "./CandidateInfo";
import CandidateOverview from "./CandidateOverview";
import DetailedPerformanceRatings from "./DetailedPerformanceRatings";

const CandidateReportPage = () => {
  const { t, i18n } = useTranslation("goHire", { keyPrefix: "candidateReportPage" });
  const navigate = useNavigate();
  const { jobId, candidateId, reviewId } = useParams<{ jobId: string; candidateId: string; reviewId: string }>();

  const handleNavigateBackToJobDetails = () => navigate(getJobDetailsRoute(jobId!));

  const { data: reviewResponse, isLoading: isReviewLoading } = useGetCandidateReview({
    jobId: jobId!,
    candidateId: candidateId!,
  });

  const { data: user, isLoading: isUserLoading } = useUserProfile(candidateId!);

  if (isReviewLoading || isUserLoading) {
    return <></>;
  }

  if (!user) {
    return (
      <Box sx={styles.container}>
        <Typography>{t("noDataFound")}</Typography>
      </Box>
    );
  }

  const reviewData = reviewResponse?.data;
  const review = reviewData?.review;

  return (
    <Box sx={styles.container} component="main">
      <Box sx={styles.header}>
        <IconButton size="small" onClick={handleNavigateBackToJobDetails}>
          <BackButtonIcon />
        </IconButton>
        <Typography sx={styles.title}>{t("candidateReportView", { candidateName: user.firstName })}</Typography>
      </Box>
      <UnlockAdvancedHiringTools />
      <CandidateInfo
        user={user}
        jobName={reviewData?.jobName}
        overallFitScore={review?.overallFitScore}
        createdAt={review?.createdAt}
      />
      <CandidateOverview user={user} criteria={review?.criteria || []} />
      {/* <GinoCandidateSummary ginoFitScoreData={reportInfoData.ginoFitScoreData} /> */}
      <DetailedPerformanceRatings criteria={review?.criteria || []} />
    </Box>
  );
};

export default CandidateReportPage;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
};
